import get from "lodash/get";

import { PAYLOAD_STATUS, STATUS_OK, STATUS_PENDING } from "../status";

export const isUpdatingResponse = state =>
  get(state, ["status", "payload", "value"], "") === STATUS_PENDING;

export const isResponseSaved = state =>
  get(state, ["status", PAYLOAD_STATUS, "value"], "") === STATUS_OK;
